import { BackLink } from '../components/layout/BackLink';
import { SchedulesSection } from '../components/schedule/SchedulesSection';

export function SchedulesPage() {
  return (
    <>
      <BackLink />
      <h1>Schedules</h1>
      <SchedulesSection />
    </>
  );
}
